import { useQuery } from 'react-query';
import { getInsurances, getInsurancesGroups, getInsurancesML } from '@/services/insurances';

export const useGetInsurances = ({
	page = 1,
	limit = 50,
	search = '',
	sort = '',
	enabled = true,
}: {
	page?: number;
	limit?: number;
	search?: string;
	sort?: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['insurances', page, limit, search, sort],
		queryFn: () => getInsurances(page, limit, search, sort),
		enabled,
		keepPreviousData: false,
		// staleTime: 5 * 60 * 1000, // 5 minutes
		// cacheTime: 10 * 60 * 1000, // 10 minutes
	});
};

export const useGetInsurancesMl = ({
	page = 1,
	limit = 50,
	search = '',
	typeId = '',
	topId,
	enabled = true,
}: {
	page?: number;
	limit?: number;
	search?: string;
	typeId?: string;
	topId?: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['insurances-ml', page, limit, search, typeId, topId],
		queryFn: () => getInsurancesML(page, limit, search, typeId, topId),
		enabled,
		keepPreviousData: false,
		// staleTime: 5 * 60 * 1000, // 5 minutes
		// cacheTime: 10 * 60 * 1000, // 10 minutes
	});
};

export const useGetInsurancesGroups = ({
	enabled = true,
}: {
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['insurances-group',],
		queryFn: () => getInsurancesGroups(),
		enabled,
		keepPreviousData: false,
		// staleTime: 5 * 60 * 1000, // 5 minutes
		// cacheTime: 10 * 60 * 1000, // 10 minutes
	});
};
